import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { OffersSettingsNew } from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/offersSettingsNew/OffersSettingsNew';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { FullWidthButton } from './ContactPreferencesNew.style';
import { useCommon } from 'src/domains/common/Common';
import { ContactPreferencesNewState, ContactPreferencesNewStateInfoMessageType } from './ContactPreferencesNew.state';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

const renderMessage = (infoMessage: ContactPreferencesNewStateInfoMessageType): JSX.Element | string => {
    if (infoMessage === 'error') {
        return (
            <Messages
                type='error'
                marginTop='8px'
                message={
                    <I18n
                        langKey='account.contact-preferences.error-message'
                        defaultText='Sorry, we seem to have a problem. Please try again.'
                    />
                }
            />
        );
    } else if (infoMessage === 'success') {
        return (
            <Messages
                type='success'
                marginTop='8px'
                message={
                    <I18n
                        langKey='account.contact-preferences.success-message'
                        defaultText='Contact preferences have been successfully changed.'
                    />
                }
            />
        );
    }

    return '';
};

export const ContactPreferencesNew = observer('ContactPreferencesNew', () => {
    const common = useCommon();
    const basicData = BasicDataModel.get(common);
    const [contactPreferences] = useState(() => new ContactPreferencesNewState(common));
    const config = ConfigComponents.get(common);
    const { contactPreferencesCategories } = config.config;

    const data = basicData.basicDataReady;
    const id = data?.id ?? null;
    const email = data?.contactPreferencesByCategory?.find((item) => item.type === 'email');
    const phone = data?.contactPreferencesByCategory?.find((item) => item.type === 'phone');
    const sms = data?.contactPreferencesByCategory?.find((item) => item.type === 'sms');

    const state = contactPreferences.offersContactPreferencesNewStateAuto.get([
        email?.categories ?? [],
        phone?.categories ?? [],
        sms?.categories ?? [],
    ]);

    return (
        <div>
            <OffersSettingsNew
                state={state}
                contactPreferencesCategories={contactPreferencesCategories}
                variant='light'
            />
            <FullWidthButton
                size='large'
                dataTest='save-contact-preferences-button'
                onClick={(): Promise<void> => contactPreferences.submitContactPreferences(id, state)}
            >
                <I18n
                    langKey='account.contact-preferences.new.button'
                    defaultText='Save'
                />
            </FullWidthButton>
            {renderMessage(contactPreferences.infoMessage)}
        </div>
    );
});
